import type { ComponentPropsWithoutRef } from 'react';

type BrandWordmarkProps = Omit<ComponentPropsWithoutRef<'img'>, 'src'>;

/**
 * The approved reversed wordmark for every dark web surface. The asset is
 * emitted from the canonical mobile brand export by Vite, so web cannot drift
 * back to a separately maintained logo file.
 */
export function BrandWordmark({ alt = '18Gimmies', ...props }: BrandWordmarkProps) {
  return <img src="/assets/18gimmies-wordmark-white.png" alt={alt} {...props} />;
}
